"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// ----------------------------------------------------------------------
function DatePicker(theme) {
    return {
        MuiDatePicker: {
            defaultProps: {
                inputFormat: 'dd/MM/yyyy',
            },
        },
    };
}
exports.default = DatePicker;
